import React, {Fragment} from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route } from "react-router-dom";
import NotFound from './components/notFound';
import  Header from './components/common/Header';
import ChatSurvey from './components/chatSurvey';
import CustomComponent from './components/customComponent';
import './App.css';
import WidgetContext from './context/WidgetContext';
import { endConversation } from "xav-chat-widget";
import MuiSnackbarCustom from './components/common/Snackbar';
import { removeFromSession } from './utils/common';
import { USER_DETAIL_SESSION_KEY, USER_TIME_SESSION_KEY, APP_CLIENTS } from './utils/constants';
import {Helmet} from "react-helmet";
const {PUBLIC_URL, REACT_APP_CLIENT} = process.env;

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isWidgetOpen: false,
      isCloseClicked: false
    };
  }

  onCloseClicked=()=>{
    endConversation(true, ()=>{
      this.setState({isWidgetOpen: false})
    })
  }

  contextValue=()=>{
    return{
      isWidgetOpen: this.state.isWidgetOpen,
      isCloseClicked: this.state.isCloseClicked,
      toggleWidgetContext: (toggle, isCloseClicked)=>{
        this.setState({isWidgetOpen: toggle, isCloseClicked: isCloseClicked});
        if(isCloseClicked){
          this.onCloseClicked();
          removeFromSession(USER_DETAIL_SESSION_KEY);
          removeFromSession(USER_TIME_SESSION_KEY);
        }
      }
    }
  }

  getDocumentTitle=()=>{
    if(REACT_APP_CLIENT===APP_CLIENTS.uber){
      return "UBER Technician";
    }else{
      return "Lighthouse";
    }
  }

  render() {
    return (
      <div className="sds-root">
        <Helmet><title>{this.getDocumentTitle()}</title></Helmet>
        <WidgetContext.Provider value={this.contextValue()}>
          <Fragment>
            <Header/>
            <MuiSnackbarCustom />
            <Router basename={PUBLIC_URL}>
              <Routes>
                <Route
                  path="/home"
                  exact
                  element={<CustomComponent/>}
                />

                <Route
                  path="/success"
                  exact
                  element={<ChatSurvey/>}/>
                <Route
                  path="/not-found"
                  exact
                  element={<NotFound/>}
                />

                <Route
                  path="/"
                  element={<Navigate to="/home" />}
                />

              </Routes>
            </Router>
          </Fragment>
        </WidgetContext.Provider>
      </div>
    )
  }
}
